<template>
  <el-form
      class="demo-ruleForm"
      ref="lform"
      :model="form"
      :rules="rules"
      label-width="0">
    <el-form-item prop="mobile">
      <el-input type="number" v-model="form.mobile" placeholder="手机号">
        <i slot="prefix" class="el-icon-phone-outline cl111 login-Icon f17"></i>
      </el-input>
    </el-form-item>
    <el-form-item prop="code">
      <el-input type="number" v-model="form.code" placeholder="请输入手机验证码">
        <img slot="prefix" class="login-Icon" src="@/assets/slices/security-safe.png"/>
        <el-button slot="suffix" :disabled="codeCd" type="primary" size="mini" @click="getcodeCd">
          <span v-if="!codeCd">发送验证码</span>
          <span v-else>{{ long }}s</span>
        </el-button>
      </el-input>
    </el-form-item>
    <el-form-item prop="new_password">
      <el-input type="new_password" v-model="form.new_password" autocomplete="off" placeholder="登录密码">
        <img slot="prefix" class="login-Icon" src="@/assets/slices/lock.png"/>
      </el-input>
    </el-form-item>
    <el-form-item prop="password1">
      <el-input type="new_password" v-model="form.password1" autocomplete="off" placeholder="确认密码">
        <img slot="prefix" class="login-Icon" src="@/assets/slices/lock.png"/>
      </el-input>
    </el-form-item>
<!--    <el-form-item prop="code">
      <el-input v-model="form.code" auto-complete="off" placeholder="验证码">
        <img slot="prefix" class="login-Icon" src="@/assets/slices/security-safe.png"/>
        <img slot="suffix" :src="codeUrl" class="login-code" @click="getCode"/>
      </el-input>
    </el-form-item>-->
    <el-form-item>
      <el-button
          :loading="loading"
          :disabled="loading"
          size="medium"
          type="danger"
          round
          @click="resetPassword"
          style="width:100%;background-color: #C32912;color: #fff">
        <span v-if="!loading">提交验证</span>
        <span v-else>验 证 中...</span>
      </el-button>
    </el-form-item>
  </el-form>
</template>
<script>
import {resetPassword} from "@/api/api";

export default {
  name: "Forgot-new_password",
  props: {
    codeCd: {
      type: Boolean,
      default: false
    },
    long: {
      type: Number,
      default: 15
    },
    codeUrl: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      // 获取验证码
      getCode() {
        this.$emit('getCode');
      },
      title: "用户登录",
      loading: false,
      form: {
        mobile: "",
        code: "",
        new_password: "",
        password1: "",
      },
      rules: {
        mobile: [
          {required: true, message: "请输入手机号", trigger: "blur"},
          {
            pattern: /^1[3456789]\d{9}$/,
            message: "请输入正确的手机号",
            trigger: "blur"
          }
        ],
        code: [{required: true, message: "请输入手机验证码", trigger: "blur"}],
        new_password: [{required: true, message: "请输入密码", trigger: "blur"},],
        password1: [
          {required: true, message: "请输入确认密码", trigger: "blur"},
          {
            validator: (rule, value, callback) => {
              if (value !== this.form.new_password) {
                callback(new Error("两次输入的密码不一致"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
      },
      checked: false,
    }
  },
  mounted() {

  },
  methods: {
    getcodeCd() {
      this.$emit('getcodeCd', this.form.mobile);
    },
    resetPassword() {
      this.$refs.lform.validate(valid => {
        if (valid) {
          this.loading = true;
          resetPassword(this.form).then(res => {
            this.loading = false;
            console.log('请求成功', res);
            this.resetForm('lform')
            // 密码重置成功
            this.$message({
              message: "密码重置成功",
              type: "success"
            });
            this.$emit('toggle', '用户登录');
          }).catch(e => {
            this.loading = false;
            this.$message({
              message: "网络或程序异常！" + e,
              type: "error"
            });
          });
        } else {
          this.$message({
            message: "请输入合法的值",
            type: "error"
          });
          return false;
        }
      });
    },
    // 重置表单
    resetForm(formName) {
      this.$refs[formName].clearValidate(); //清除验证
      this.$refs[formName].resetFields(); //重置表单
    }
  }
}
</script>

<style scoped lang="scss">

</style>
